



export enum MSG {
    MovementEnd = "points mapped complete",
    NOLOC = 'No location data for today. Click on `Last Position` and then check again',
    NORTDATA = 'no realtime data available',
    NODATA = 'waiting for location data...',
    MAX_MOVEMENT_REACHED = 'you have reached the maximum history data',
    APP_ERROR = 'an application error has occurred',
    UPGRADE_MSG = "kindly contact the admin to upgrade your account.",
    NEWTRACKER = "only adminstrators can add a new tracker",
}

export enum URLENUM {

    google_search = "https://www.google.com.ng/maps/search/",
    google_traffic = "https://www.google.com.ng/maps/dir/",
    traffic_simulation = '/dashboard/traffic_simulation',
    last_seen = '/dashboard/lastseen',
    movement_history = '/dashboard/movement_history',
    team_member = "/teamuser/",
    team_member_add = "/teamuser/add",
    team_member_edit = "/teamuser/edit/",
    report = "/report/",
    device = "/devices/",
    device_edit = "/devices/edit/",
    settings = "/settings/",
    settings_update = "/settings/update/",
    logout = "/#/logout",
    
 

}
